export enum WorkItemPageTypes {
  InactivePage = "Work Items - Inactive",
  ActivePage = "Work Items - Active",
  MyWorkPage = "My Work Items",
}
